module.exports = __webpack_public_path__ + "components/home-header/static/header-3--medium-934240a291683e0f14aa503f47ba8cfb.jpg";